import { render, staticRenderFns } from "./voiceControlModal.vue?vue&type=template&id=0a6b4c38&scoped=true"
import script from "./voiceControlModal.vue?vue&type=script&lang=js"
export * from "./voiceControlModal.vue?vue&type=script&lang=js"
import style0 from "./voiceControlModal.vue?vue&type=style&index=0&id=0a6b4c38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6b4c38",
  null
  
)

export default component.exports